import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { ProductAction } from '../../actions';
import { history } from '../../history';
import { Loading } from '../common/Loading';
import { Translate as t } from '../../config/Translate';
import { interpolate } from '../../config/i18nInterpolate';

const ProductDelete = ({ product, isUpdateRes, DeleteProduct, ClearUpdateResult }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [delCheckResult, setDelCheckResult] = useState({
        hasSite: product.siteId,
        errCount: product.errs,
        acqCount: product.acquisitions,
        warCount: product.waranties
    });

    useEffect(() => {
        setIsLoading(false)
        if (isUpdateRes) {
            ClearUpdateResult();
            history.push("/Admin/AdminProductList");
        }
    }, [isUpdateRes]);

    return (
        <>
            {/* {delCheckResult.hasSite && (
                <>
                    <div className="card bg-danger text-white">
                        <div className="card-header">
                            <div className="card-title">경고!</div>
                        </div>
                        <div className="card-body">
                            <h4>아래의 사유로 {product.sn}을/를 삭제할 수 없습니다</h4>
                        </div>
                        <ul className="list-group">
                            <li className="list-group-item"> <Link to={"/Admin/AdminSiteInfo/" + product.siteId}>{product.site.sitename}</Link>에 설치된 장비입니다.  </li>
                        </ul>
                    </div>
                </>
            )} */}
            {product && product._id && (
                <>
                    <div className="card bg-danger text-white">
                        <div className="card-header">
                            <div className="card-title">{t('common.label.warning')}</div>
                        </div>
                        <div className="card-body">
                            <h4>{t('common.message.delete.appliedImmediately')}</h4>
                            <p>{t('common.message.delete.irreversible')}</p>
                            <p>{t('common.message.confirm.delete')}</p>
                            <ul className="list-group">
                                {delCheckResult.errCount > 0 && <li className="list-group-item"> {interpolate(t('product.delete.reasonErrors'), { count: delCheckResult.errCount })}</li>}
                                {delCheckResult.acqCount > 0 && <li className="list-group-item"> {interpolate(t('product.delete.reasonAcq'), { count: delCheckResult.acqCount })}</li>}
                                {delCheckResult.warCount > 0 && <li className="list-group-item"> {interpolate(t('product.delete.reasonWarranty'), { count: delCheckResult.warCount })}</li>}
                            </ul>
                        </div>
                    </div>
                    <button className="btn btn-outline-danger" onClick={() =>{ setIsLoading(true); DeleteProduct(product._id); }}>{t('product.button.deleteProduct')}</button>
                </>
            )}
            {isLoading && <div className="" style={{ marginTop : 120 }}>
				<Loading />
			</div>}
        </>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.ProductReducer.isUpdateRes;
    return { isUpdateRes };
}

const mapDispatch = dispatch => ({
    ClearUpdateResult: () => dispatch(ProductAction.ClearUpdateResult()),
    DeleteProduct: (_id) => dispatch(ProductAction.DeleteProduct(_id))
})

export default connect(mapState, mapDispatch)(ProductDelete);